import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { Typography, Select, MenuItem, Button } from "@material-ui/core";
import { TimereportDto } from "@api/timereports";
import { SpinnerOverlay } from "@common";
import locale from "@bonliva-crm/locale";

type Props = {
  loading: boolean;
  items: TimereportDto[];
  onAttach: (timereport: TimereportDto) => void;
};

export function FreeTimereportSelector({ items, loading, onAttach }: Props) {
  const [selectedId, setSelectedId] = useState(items[0]?.id);
  const isEmptyItems = isEmpty(items);

  useEffect(() => {
    if (selectedId && !isEmptyItems && !items.find((x) => x.id === selectedId)) {
      setSelectedId(items[0]?.id);
    }
  }, [items]);

  if (isEmptyItems) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 10,
        marginBottom: 10
      }}
    >
      <SpinnerOverlay show={loading} />

      <Typography style={{ maxWidth: 135 }} variant={"caption"}>
        {locale.AddToTimeReport}
      </Typography>

      <Select
        onChange={(e) => setSelectedId(e.target.value as string)}
        value={selectedId}
        style={{ maxWidth: 135, minWidth: 135 }}
      >
        {items.map((item) => (
          <MenuItem value={item.id} key={item.id}>
            <Typography noWrap>
              {item.workplace} ({item.department})
            </Typography>
          </MenuItem>
        ))}
      </Select>

      <Button
        variant={"contained"}
        color={"primary"}
        style={{ maxWidth: 135, minWidth: 135 }}
        disabled={!selectedId}
        onClick={() => selectedId && onAttach(items.find((x) => x.id === selectedId))}
      >
        {locale.Save}
      </Button>
    </div>
  );
}
